import { NgModule } from '@angular/core';
import { ContractGeneratedSvgComponent } from './contract-generated/contract-generated.component';
import { ContractGeneratingSvgComponent } from './contract-generating/contract-generating.component';
import { ErrorOutlineSvgComponent } from './error-outline/error-outline.component';
import { ForUploadSvgComponent } from './for-upload/for-upload.component';
import { DoneOutlineSvgComponent } from './done-outline/done-outline.component';
import { LoaderSvgComponent } from './loader/loader.component';
import { SaveSvgComponent } from './save/save.component';
import { PdfSvgComponent } from './pdf/pdf.component';
// ----------------------------------------------------------------------------------------------------
@NgModule({
  declarations: [
    ContractGeneratingSvgComponent,
    ContractGeneratedSvgComponent,
    ErrorOutlineSvgComponent,
    ForUploadSvgComponent,
    DoneOutlineSvgComponent,
    LoaderSvgComponent,
    SaveSvgComponent,
    PdfSvgComponent
  ],
  exports: [
    ContractGeneratingSvgComponent,
    ContractGeneratedSvgComponent,
    ErrorOutlineSvgComponent,
    ForUploadSvgComponent,
    DoneOutlineSvgComponent,
    LoaderSvgComponent,
    SaveSvgComponent,
    PdfSvgComponent
  ]
})
export class SvgsModule { }
